import script from "./FilePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./FilePreview.vue?vue&type=script&setup=true&lang=js"

import "./FilePreview.vue?vue&type=style&index=0&id=b854a15e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b854a15e"]])

export default __exports__